<template>
	<div>
		<el-form class="form1" :model="queryParams" ref="queryForm" :inline="true" label-width="150px" v-show="isTable">
			<el-row>
				<el-col :span="12">
					<el-form-item  prop="publishUnitName">
						<el-input v-model="queryParams.publishUnitName" placeholder="请输入发布单位名称" />
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item  prop="publishUnitName">
						<el-input v-model="queryParams.publishContent" placeholder="请输入企业对外发布的服务与需求" />
					</el-form-item>
				</el-col>
			</el-row>
			<el-row>
				<el-col :span="12">
					<el-form-item  prop="publishUnitName">
						<el-date-picker
						  v-model="times"
						  @change="timeDate"
						  type="daterange"
						  unlink-panels
						  range-separator="至"
						  start-placeholder="请选择开始日期"
						  end-placeholder="请选择截止日期"
						  :picker-options="pickerOptions"
						  value-format="yyyy-MM-dd">
						</el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item>
						<el-button type="primary" size="small" @click="getList">检索</el-button>
						<el-button type="warning" size="small" @click="toAdd">新增发布</el-button>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>	
		<div v-show="isTable">
			<el-table v-loading="loading" :data="list">
			  <el-table-column type="index" label="序号" width="55" align="center" />
				<el-table-column label="发布标题" align="center" prop="publishTitle" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<el-link :underline="false" type="primary" @click="openReply(scope.row)">{{scope.row.publishTitle}}</el-link>
					</template>
				</el-table-column>
			  <el-table-column label="发布单位名称" align="center" prop="publishUnitName" :show-overflow-tooltip="true"/>
			  <el-table-column label="发布单位联系电话" align="center" prop="publishTel" />
			  <el-table-column label="发布时间" align="center" prop="publishTime" width="180">
			    <template slot-scope="scope">
			      <span>{{ parseTime(scope.row.publishTime, '{y}-{m}-{d} {h}:{m}:{s}') }}</span>
			    </template>
			  </el-table-column>
			</el-table>
			<pagination v-show="total>0" :total="total" :page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize" @pagination="getList" />
		</div>
		<div v-show="isReply" style="margin-top: 2rem;">
			<el-form ref="form" :model="form" :rules="rules" label-width="150px">
			  <el-form-item label="发布单位名称" prop="publishUnitName">
			    <el-input v-model="form.publishUnitName" placeholder="请输入单位名称" disabled />
			  </el-form-item>
			  <el-form-item label="发布单位联系电话" prop="publishTel">
			    <el-input v-model="form.publishTel" placeholder="请输入发布单位联系电话" />
			  </el-form-item>
			  <el-form-item label="发布标题" prop="publishTitle">
			    <el-input v-model="form.publishTitle" placeholder="请输入发布标题" />
			  </el-form-item>
			  <el-form-item label="科技合作意向或需求" prop="publishContent">
			    <el-input type="textarea" maxlength="4000" show-word-limit :autosize="{ minRows: 2, maxRows: 10}"  v-model="form.publishContent" placeholder="请输入科技合作意向或需求" />
			  </el-form-item>
			  <el-button type="primary" @click="submitForm">提交发布</el-button>
				<el-button @click="toListPage">返回</el-button>
			</el-form>
		</div>
		<div v-show="isDetail">
			<el-row style="margin-bottom: 1rem;">
			  <el-col :span="8">
			    <div class="ti">
			      <el-avatar size="medium" :src="jgsrc" v-if="replyOptions.kjjlDetail.publishType=='1'" /></el-avatar>
			      <el-avatar size="medium" :src="qysrc" v-else></el-avatar>
			      <span style="margin-left: 1rem;">{{replyOptions.kjjlDetail.publishUnitName}}</span>
			    </div>
			  </el-col>
			  <el-col :span="8">
			    <div style="line-height: 2.25rem;">
			      发布时间：<span style="color: #1890FF;">{{parseTime(replyOptions.kjjlDetail.publishTime, '{y}-{m}-{d} {h}:{m}:{s}')}}</span>
			    </div>
			  </el-col>
			  <el-col :span="6">
			    <div style="float: left;line-height: 2.25rem;">
			      <i class="el-icon-view"></i>
			      浏览：<span style="color: #fab050;">{{replyOptions.browseCount}}</span>
			    </div>
			    <div style="float: right;line-height: 2.25rem;">
			      <i class="el-icon-chat-dot-round"></i>
			      回复贴：<span style="color: #fab050;">{{replyOptions.total}}</span>
			    </div>
			  </el-col>
			</el-row>
			<el-row>
			  <el-col :span="24">
			    <el-descriptions :title="replyOptions.kjjlDetail.publishTitle" :colon="false">
			      <el-descriptions-item >{{replyOptions.kjjlDetail.publishContent}}</el-descriptions-item>
			    </el-descriptions>
			  </el-col>
			</el-row>
			<el-divider>评论区</el-divider>
			<el-form ref="replyForm" :model="replyOptions.replyForm" :rules="replyOptions.replyRules" label-width="100px">
			  <el-row style="margin-bottom: 1rem;">
			    <el-col :span="12">
			      <div class="ti">
			        <el-avatar size="medium" :src="qysrc" /></el-avatar>
			        <span style="margin-left: 1rem;">{{replyOptions.replyForm.replyName}}</span>
			      </div>
			    </el-col>
			  </el-row>
			  <el-row>
			    <el-col :span="24">
			      <el-form-item label="我要回复" prop="replyContent">
			        <el-input maxlength="4000" show-word-limit type="textarea" v-model="replyOptions.replyForm.replyContent" placeholder="请输入回复内容"
							    :autosize="{ minRows: 4, maxRows: 10}"/>
			      </el-form-item>
			    </el-col>
			  </el-row>
			  <el-row>
			    <el-col :span="22">
			      <el-button style="float: right;" type="primary" @click="submitReply">发布评论</el-button>
			    </el-col>
				  <el-col :span="2">
					  <el-button  style="float: right;" @click="toListPage">返回</el-button>
				  </el-col>
			  </el-row>
			</el-form>
			<div v-for="(item,index) in replyOptions.ywKjjlOperationList" :key="index"
			style="margin-top: 1rem;padding-bottom: 1rem; border-bottom: 0.0625rem solid #bdbdbd;">
			  <el-row style="margin-bottom: 1rem;">
			    <el-col :span="24">
			      <div class="ti">
			        <el-avatar size="medium" :src="item.unitDeptCode != null ? jgsrc : qysrc"  /></el-avatar>
			        <span style="margin-left: 1rem;">{{item.replyName}}</span>
			        <span style="color: #939393;margin-left: 1rem;">{{parseTime(item.replyTime, '{y}-{m}-{d} {h}:{m}:{s}')}}</span>
			      </div>
			    </el-col>
			  </el-row>
			  <el-row>
			    <el-col :span="24">
			      <span style="margin-left: 3.25rem;">{{item.replyContent}}</span>
			    </el-col>
			  </el-row>
			</div>
		</div>
	</div>
</template>

<script>
import { listYwKjjl, getYwKjjl, delYwKjjl, addYwKjjl, updateYwKjjl, exportYwKjjl } from "@/api/kjjl/ywKjjl";
import {listYwKjjlOperation,addYwKjjlOperation} from "@/api/kjjl/ywKjjlOperation";
import {
		getBrowseCount
	} from "@/api/basedata/records";
	export default {
		name: 'qygzsKjjl',
		data() {
			const checkPhone = (rule, value, callback) => {
			  let regPone = null
			  let mobile = /^(1[3456789]\d{9})$/  //手机号
			  let tel = /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/ // 座机
			  if (value !== null && value.charAt(0) === '0') { // charAt查找第一个字符方法，用来判断输入的是座机还是手机号
			    regPone = tel
			  } else if (value !== null && value.charAt(0) !== '0') {
			    regPone = mobile
			  }
			  if (regPone === null) {
			    return callback(
			         new Error('请输入电话')
			    )
			  } else if (!regPone.test(value)) {
			    return callback(
			         new Error("请输入正确的电话格式,其中座机格式'区号-座机号码'")
			    )
			  } else {
			    callback()
			  }
			};
			return {
				// 遮罩层
				loading: false,
				// 总条数
				total: 0,
				list: [],
				queryParams: {
					pageNum: 1,
					pageSize: 10,
					publishUnitName:undefined,
					publishContent:undefined
				},
				isTable:true,
				isDetail:false,
				isReply:false,
				//时间数组
				times:undefined,
				pickerOptions: {
				  shortcuts: [{
				    text: '最近一周',
				    onClick(picker) {
				      const end = new Date();
				      const start = new Date();
				      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
				      picker.$emit('pick', [start, end]);
				    }
				  }, {
				    text: '最近一个月',
				    onClick(picker) {
				      const end = new Date();
				      const start = new Date();
				      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
				      picker.$emit('pick', [start, end]);
				    }
				  }, {
				    text: '最近三个月',
				    onClick(picker) {
				      const end = new Date();
				      const start = new Date();
				      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
				      picker.$emit('pick', [start, end]);
				    }
				  }]
				},
				// 表单参数
				form: {
				},
				jgsrc:require('../../assets/jg.png'),
				qysrc:require('../../assets/qy.png'),
				// 表单校验
				rules: {
				  publishUnitName: [
				    {required: true, message: '请输入发布单位名称', trigger: 'blur'}
				  ],
				  publishTel: [
				    {required: true, message: '请输入发布单位联系电话', trigger: 'blur'},
				    { validator: checkPhone, trigger: "blur" },
				  ],
				  publishTitle: [
				    {required: true, message: '请输入发布标题', trigger: 'blur'}
				  ],
				  publishContent: [
				    {required: true, message: '请输入科技合作意向或需求', trigger: 'blur'}
				  ],
				},
				replyOptions:{
				  title: '查看帖子',
				  replyOpen: false,
				  replyForm:{
				    replyContent:undefined,
				    parentRecid:undefined,
				    ywFwjgRecid:undefined,
					replyName:undefined,
				  },
				  replyRules: {
				    replyContent: [
				      {required: true, message: '请输入回复内容', trigger: 'blur'},
				    ],
				  },
				  kjjlDetail:{
					  publishType:''
				  },
				  browseCount:0,
				  ywViews:{
				  	busRecid:undefined,
				  	busTableName:'yw_kjjl',
				  },
				  loading: true,
				  // 总条数
				  total: 0,
				  // 科技交流回复表格数据
				  ywKjjlOperationList: [],
				  queryParams: {
				    pageNum: 1,
				    pageSize: 10,
				    parentRecid: undefined,
				  },
				}
			}
		},
		created() {
			this.getList();
			 this.loginUser();
		},
		methods: {
			loginUser(){
				//----【】需要修改为recid
				let ssessionLoginUser = JSON.parse(localStorage.getItem('ssessionLoginUser'));
				this.form.publishUnitName = ssessionLoginUser.user.corname;
				this.form.publishYwFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
				this.form.createBy = ssessionLoginUser.user.ywFwjgRecid;
				this.replyOptions.replyForm.ywFwjgRecid = ssessionLoginUser.user.ywFwjgRecid;
				this.replyOptions.replyForm.replyName=ssessionLoginUser.user.corname;
				
				/* let uuid=localStorage.getItem("sdtyfwpt_uuid");
				this.getLoginUser(uuid).then(response => {
					let entname=response.data.user.corname;
					let ywFwjgRecid = response.data.user.ywFwjgRecid;
					this.form.publishUnitName = entname;
					this.form.publishYwFwjgRecid = ywFwjgRecid;
					this.form.createBy = ywFwjgRecid;
					this.replyOptions.replyForm.ywFwjgRecid = ywFwjgRecid;
					this.replyOptions.replyForm.replyName=entname;
				}) */
			},
			timeDate(value){
			  if (value == null) {
			    this.queryParams.startTime = "";
			    this.queryParams.entTime = "";
			  }
			},
			getList() {
				if (this.times != undefined && this.times != '' && this.times!= null){
				  this.queryParams.startTime = this.times[0]
				  this.queryParams.entTime = this.times[1]
				}
				this.loading = true;
				listYwKjjl(this.queryParams).then(response => {
					this.list = response.rows;
					this.total = response.total;
					this.loading = false;
				});
			},
			toAdd(){
				this.isTable = false;
				this.isDetail = false;
				this.isReply = true;
			},
			/** 提交按钮 */
			submitForm: function() {
			  this.$refs["form"].validate(valid => {
			    if (valid) {
					addYwKjjl(this.form).then(response => {
					  if (response.code === 200) {
						this.msgSuccess("发布成功");
						this.getList();
						this.isTable = true;
						this.isDetail = false;
						this.isReply = false;
					  } else {
						this.msgError(response.msg);
					  }
					});
			    }
			  });
			},
			openReply(row){
			  this.replyOptions.replyForm.parentRecid = undefined;
			  this.replyOptions.replyForm.replyContent = undefined;
			  this.replyOptions.kjjlDetail = row;
			  this.replyOptions.queryParams.parentRecid = row.recid;
			  this.getBrowseData(row.recid);
			  this.getywKjjlOperationList();
			  this.isTable = false;
				this.isDetail = true;
				this.isReply = false;
			},
			getBrowseData(recid) {
				this.replyOptions.ywViews.busRecid= recid;
				getBrowseCount(this.replyOptions.ywViews).then(response => {
					this.replyOptions.browseCount = response;
				})
			},
			getywKjjlOperationList() {
			  this.replyOptions.loading = true;
			  listYwKjjlOperation(this.replyOptions.queryParams).then(response => {
			    this.replyOptions.ywKjjlOperationList = response.rows;
			    this.replyOptions.total = response.total;
			    this.replyOptions.loading = false;
			  });
			},
			toListPage(){
				this.getList();
				this.isTable = true;
				this.isDetail = false;
				this.isReply = false;
			},
			submitReply: function() {
			  this.$refs["replyForm"].validate(valid => {
			    if (valid) {
			      this.replyOptions.replyForm.parentRecid = this.replyOptions.kjjlDetail.recid;
			      this.replyOptions.replyForm.ywFwjgRecid = this.form.publishYwFwjgRecid;
			      addYwKjjlOperation(this.replyOptions.replyForm).then(response => {
			        if (response.code === 200) {
			          this.msgSuccess("回复成功");
						this.replyOptions.replyForm.replyContent = undefined;
						this.getywKjjlOperationList();
						this.isTable = false;
						this.isDetail = true;
						this.isReply = false;
			        } else {
			          this.msgError(response.msg);
			        }
			      });
			    }
			  });
			}
		}
	}
</script>

<style scoped="scoped">
	.el-select{
		width: 21.25rem;
	}
	.form1 /deep/ input{
		width: 21.875rem;
	}
	.ti img,span {
	  vertical-align: middle;
	}
	*{
		text-align: left !important;
	}
</style>
